import React from 'react';
import { toast } from 'react-toastify';
import { useDispatch } from 'react-redux';
import { CancelNewOrderButtonProps } from './types';
import { useCancelOrderMutation } from '@src/features/order/redux';
import { ArcButton } from '@src/core/ui';
import { setSelectedOrder } from '@src/features/order/pages/orders-page/redux';
import { trackError, toTrackedError } from '@src/core/sentry';

const CancelNewOrderButton: React.FC<CancelNewOrderButtonProps> = (props) => {
  const { orderId } = props;

  const dispatch = useDispatch();
  const [cancelOrder, { isLoading }] = useCancelOrderMutation();

  const onCancelOrder = () => {
    cancelOrder(orderId).unwrap().then(() => {
      dispatch(setSelectedOrder(null));
      toast.success('Order has been successfully canceled');
    }).catch((err: unknown) => {
      trackError(toTrackedError(err), { code: 'FE_0020', extra: { flow: 'cancelNewOrder' } });
    });
  };
  
  return (
    <ArcButton.ghost 
      fullWidth 
      isLoading={isLoading}
      onClick={onCancelOrder}>
      Delete mission
    </ArcButton.ghost>
  );
};

export default CancelNewOrderButton;